export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.permissions': '权限管理',
  'menu.talent-review': '人才盘点',
  'menu.talent-review.workbench': '盘点工作台',
  'menu.talent-review.cycles': '周期管理',
  'menu.talent-review.participants': '名单核定',
  'menu.talent-review.scoring': '评分录入',
  'menu.talent-review.results': '结果校验',
  'menu.talent-review.dashboard': '基础看板',
  'menu.talent-review.job-profiles': '岗位画像',
  'menu.talent-review.fit-analysis': '适配分析',
  'menu.talent-review.reports': '盘点报告',
  'menu.talent-review.employee-detail': '员工详情',
  'menu.talent.list': '人才档案',
  'menu.talent.detail': '人才详情',
  'menu.review.grid': '人才盘点',
  'menu.review.tasks': '盘点任务',
  'menu.review.tasks.detail': '盘点任务执行',
  'menu.interview': '人才访谈',
  'menu.interview.session': '访谈执行',
  'menu.pool': '人才库',
  'menu.insights': '组织洞察',
  'menu.development.plan': '发展计划',
  'menu.succession': '继任计划',
  'menu.settings.tags': '标签配置',
  'menu.settings.model': '能力模型配置',
  'menu.settings.grid': '九宫格模型配置',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
